import { ReactNode, HTMLAttributes } from "react";
import { cn } from "@/helpers/cn";

interface FeatureCardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
}

export const FeatureCard = ({ children, className = "", ...props }: FeatureCardProps) => {
  return (
    <div
      className={cn("p-6", className)}
      style={{
        borderRadius: "0.8625rem",
        background:
          "linear-gradient(180deg, rgba(252, 252, 252, 0.00) 0.08%, #FCFCFC 100%)",
        boxShadow: "0 2.94px 44.689px 0 rgba(132, 55, 203, 0.35)",
      }}
      {...props}
    >
      {children}
    </div>
  );
};
